import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/assignedcertificates.css";
import AssignCertificateModal from "../components/assignCertficateModal";
import { get, post } from "../config/api";
import { useDispatch, useSelector } from "react-redux";
import { BackArrow } from "../constants";
import { API_ENDPOINTS } from "../constants/apiEndpoints";
import { showError, showToast } from "../store/slices/formconfig";
import { ROLES } from "../constants/textconstants";
import { EmptyList } from "../components/empty";
import { formatDateToDDMMYYYY } from "../utils/dateUtils";
import { TESTING_DATA } from "../constants/isTesting";
import { Loader } from "../components/loader";

const AssignedCertificates: React.FC = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [assignData, setAssignedData] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [users, setUsers] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const userData = useSelector((state: any) => state.formConfig.user);

  const fetchAsignedUsers = async () => {
    setIsLoading(true);
    try {
      let assignedUsers = await get(
        `${API_ENDPOINTS.USER_SUBORDINATES(userData.userId)}`
      );
      if (assignedUsers) {
        setUsers(assignedUsers);
      }
    } catch (error) {
      dispatch(showError({ message: `Failed to fetch users, due to some technical issue, please try again`, visible: true }))
            
      console.error("Failed to fetch assigned users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {

      let assignedData = [];
      if(userData.is_viewed_guided_tour){
        assignedData = await get(
        API_ENDPOINTS.CERTIFICATE_BOOKLETS_BY_USER(userData.userId)
      );
      }else{
        assignedData = TESTING_DATA.ASSIGNED_CERTIFICATES
      }
      if (assignedData) {
        setAssignedData(assignedData);
      }
    } catch (error) {
      dispatch(showError({ message: `Failed to fetch booklets, due to some technical issue, please try again`, visible: true }));
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (userData && userData.userId) {
      fetchAsignedUsers();
      fetchData();
    }
  }, [userData?.userId]);

  const getColor = (issued: number, total: number): string => {
    const percentage = (issued / total) * 100;
    if (percentage < 25) {
      return "#ff9696ff";
    } else if (percentage >= 25 && percentage <= 75) {
      return "#ffe893ff";
    } else {
      return "#9bff9eff";
    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAssignSubmit = async (formData: any) => {
  
    let assigneeInfo = formData.assignee.split("-");
    let DataToSubmit = {
      issued_by: {
        user_id: userData.userId,
      },
      issued_to: {
        user_id: assigneeInfo[0],
      },
      booklet_prefix: formData.certificatePrefix || "",
      book_start_no: formData.from,
      book_end_no: formData.to,
    };

    setIsLoading(true);
    try {
      const response = await post(
        API_ENDPOINTS.CERTIFICATE_BOOKLETS,
        DataToSubmit
      );
      if (response) {
        await fetchData();
        dispatch(showToast({ message: "Successfully assigned booklet to user.", type: "success" }));
      } else {
        dispatch(
          showError({
            message: `Failed Assigning request. Please try again. ${
              response.message ? response.message : ""
            }`,
            visible: true,
          })
        );
      }
    } catch (error: any) {
      dispatch(
        showError({
          message: `Failed Assigning request. Please try again. ${
            error.message ? error.message : ""
          }`,
          visible: true,
        })
      );
      console.error("API call failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "rgb(236, 239, 241)",
        paddingTop: 80,
        paddingBottom: 80,
      }}
    >
      {isLoading && <Loader />}
      <div style={{ padding: 20, paddingBottom: 0 }}>
        <button className="back-button" onClick={() => navigate("/")}>
          <img src={BackArrow} height={20} style={{ marginRight: 10 }} />{" "}
          Assigned Booklets
        </button>
      </div>
      <div className="assigned-certificates">
        <div className="assigned-certificates-header">
          <h3>Assigned Booklets</h3>
          <button className="assign-button" onClick={handleOpenModal}>
            Assign Booklet
          </button>
        </div>

        <table>
          <thead>
            <tr>
              <th>
                {userData && userData.role && userData.role === ROLES.APPROVER
                  ? "Territory"
                  : "Squad"}
              </th>
              <th>
                {userData && userData.role && userData.role === ROLES.APPROVER
                  ? "Issuer"
                  : "Approver"}
              </th>
              <th>Certificate no. Range</th>
              <th>Assigned Date</th>
              <th>Issued Qty</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {assignData &&
              assignData.map((cert, index) => (
                <tr key={index}>
                  <td>{cert.issuedLocation}</td>
                  <td>{cert.issued_to.username}</td>
                  <td>
                    {cert.booklet_prefix}{cert.book_start_no} - {cert.booklet_prefix}{cert.book_end_no}
                  </td>
                  <td>{formatDateToDDMMYYYY(cert.issued_date)}</td>
                  <td>
                    <div
                      style={{
                        width: 100,
                        border: "1px solid #cecece",
                        fontSize: 12,
                        position: "relative",
                      }}
                    >
                      <span
                        className="issued-qty-chart"
                        style={{
                          width: `${
                            (cert.noOfCertificatesIssued /
                              cert.totalNoOfCertificates) *
                            100
                          }%`,
                          backgroundColor: getColor(
                            cert.noOfCertificatesIssued,
                            cert.totalNoOfCertificates
                          ),
                        }}
                      ></span>
                      <span className="quantityLabel">
                        {cert.noOfCertificatesIssued}/
                        {cert.totalNoOfCertificates}
                      </span>
                    </div>
                  </td>
                  <td>
                    <button
                      className={`view-details-button ${index==0 && 'view-details-first'}`}
                      onClick={() =>
                        navigate(`/assigned-certificates/${index}`, {
                          state: { request: cert },
                        })
                      }
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {assignData && assignData.length == 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "600",
              fontSize: 12,
              height: 300,
              flexDirection: "column",
            }}
          >
            <span
              style={{
                display: "block",
                fontSize: 16,
                color: "rgba(0, 0, 0, 0.87)",
                fontWeight: "400",
                marginBottom: 5,
              }}
            >
              No certificate range assigned yet
            </span>
            <span
              style={{
                display: "block",
                fontSize: 16,
                color: "rgba(0, 0, 0, 0.60)",
                fontWeight: "400",
                marginBottom: 24,
              }}
            >
              Assign a certificate number range to enable issuance.
            </span>
          </div>
        )}
      </div>
      {isModalOpen && (
        <AssignCertificateModal
          onClose={handleCloseModal}
          onSubmit={handleAssignSubmit}
          users={users}
        />
      )}
    </div>
  );
};

export default AssignedCertificates;
